












































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { randKey } from '@/utils/random'
import TableColumn from './components/TableColumn.vue'
import { ClickPayload, Config } from '.'
import { QueryParam } from './components/query'
import { createService } from './components/service'

@Component({
  components: { TableColumn }
})
export default class Table<T> extends Vue {
  @Prop({ type: Object, required: true }) config!: Config<T>
  @Prop({ type: Array }) params!: QueryParam[] // TODO sync prop

  table = {
    data: [] as T[],
    total: 0
  }
  pagination = {
    current: 1,
    pageSize: 10
  }
  service = createService(this.config)
  loading = false
  querys = [] as QueryParam[]
  isRadio = false
  isSelection = false

  randKey = randKey()

  // watch table size
  @Watch('config', { deep: true, immediate: true })
  handleConfigChange() {
    this.service = createService(this.config)
    this.refresh()
  }

  handlePageChange(current: number) {
    this.$emit('page-change', current)
    this.pagination.current = current
    this.refresh()
  }

  handleSizeChange(size: number) {
    this.$emit('size-change', size)
    this.pagination.pageSize = size
    this.refresh()
  }

  handleCurrentChange(row: T) {
    this.$emit('current-change', row)
  }

  handleClickEvent({ event, row }: { event: string; row?: T }) {
    const payload: ClickPayload = { event, row, data: this.table.data }
    this.$emit('click', payload)
  }

  handleSearch(search: QueryParam) {
    //console.log(search) // TODO api dont support
  }

  handleSelectionChange(sel: T[]) {
    // TODO handle change
    // wrap on multi, ignore single sel
    //console.log(sel)
    this.$emit('selection-change', sel)
  }

  async refresh() {
    this.loading = true
    this.$emit('before-refresh', this.table.data)
    const re = await this.service.refresh({
      current: this.pagination.current,
      pageSize: this.pagination.pageSize,
      querys: this.querys
    })
    this.table.data = re.rows
    this.table.total = re.total
    this.loading = false
    this.$emit('refresh', re)
  }
}
